import { render, staticRenderFns } from "./CurrencyWrapper.vue?vue&type=template&id=a5916e00&"
import script from "./CurrencyWrapper.vue?vue&type=script&lang=js&"
export * from "./CurrencyWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports